import React, { useEffect } from "react";
import { X } from "lucide-react";

const Notification = ({ message, type, isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000); // Auto dismiss after 3 seconds

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen || !message) return null;

  return (
    <div
      className={`fixed top-5 right-5 z-50 flex w-80 items-center justify-between rounded-md p-4 shadow-lg transition-transform ${
        type === "success"
          ? "bg-green-700 text-white"
          : "bg-red-700 text-white"
      }`}
    >
      <span className="text-sm font-medium">{message}</span>
      <button onClick={onClose} className="ml-4 text-white hover:text-red-200 font-semibold">
        <X size={18} />
      </button>
    </div>
  );
};

export default Notification;
